import { useEffect } from 'react';
import { Article } from 't2-graphql-types';
import { postPingEvent } from './postPingEvent';
import { useAuthenticatedUser } from '../../components/Auth/hooks/useAuthenticatedUser';
import { POA_PING_EVENT_INTERVAL_IN_SECONDS } from '../../../config';
import isAppActive from '../../../utils/isAppActive';

export const useProofOfAttentionTracker = (articleId: Article['id'] | null) => {
  const { authenticatedUserId } = useAuthenticatedUser();

  useEffect(() => {
    if (!articleId || !authenticatedUserId) {
      return;
    }

    const interval = setInterval(() => {
      if (isAppActive()) {
        postPingEvent({ articleId, userId: authenticatedUserId });
      }
    }, POA_PING_EVENT_INTERVAL_IN_SECONDS * 1000);

    return () => clearInterval(interval);
  }, [articleId, authenticatedUserId]);
};
